import { Setting } from '../App';
import React, { FC, useState, useLayoutEffect } from 'react';
import classes from '../asset/css/main.module.css';
import { Form } from '../components/shipping-address-form/Form';
import { ShippingAddressType } from '../types/shipping-address-type';
import { useShippingAddress } from '../hooks/use-shipping-address';
import { useHistory } from 'react-router-dom';

export const ShippingAddressForm: FC<{ setting: Setting }> = ({ setting }) => {
  const history = useHistory();
  const [subscriptionContractId, setSubscriptionContractId] = useState('');
  const [shippingAddress, setShippingAddress] = useState<ShippingAddressType>();

  const { updateShippingAddress } = useShippingAddress(setting, setSubscriptionContractId, setShippingAddress);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight

    setting.resize(height)
  }, [shippingAddress])
 
  return (
    <>
      <div className={classes.mypage_subsc_container}>
        <Form
          shippingAddress={shippingAddress}
          changeFunc={(key, value) => {
            setShippingAddress({
              ...shippingAddress!,
              [key]: value,
            });
          }}
          submitFunc={() => {
            updateShippingAddress(
              subscriptionContractId,
              shippingAddress!,
              () => {
                history.push('/shipping-address');
              },
              (message) => console.log(message)
            );
          }}
        />
      </div>
    </>
  );
};
